module.exports = __webpack_public_path__ + "static/img/icon-2.f9518c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-4/icon-2.png
// module id = qLVJ
// module chunks = 0